export const CATALOG_ITEM_TYPE = {
  PRODUCT: 'product',
  SERVICE: 'service',
} as const
export type CatalogItemType =
  (typeof CATALOG_ITEM_TYPE)[keyof typeof CATALOG_ITEM_TYPE]
export const CATALOG_ITEM_TYPE_LABELS = {
  [CATALOG_ITEM_TYPE.PRODUCT]: 'Produto',
  [CATALOG_ITEM_TYPE.SERVICE]: 'Serviço',
}
export const CATALOG_STATUS_FILTER = {
  ALL: 'all',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const
export const CATALOG_STATUS_LABELS = {
  all: 'Todos',
  active: 'Ativos',
  inactive: 'Inativos',
}
export const CATALOG_SETTINGS_LABEL = 'Produtos/Serviços'
export const COMMERCIAL_MAX_VALUE = 9_999_999_999.99
export const CATALOG_DESCRIPTION_MAX_LENGTH = 5000
export const CATALOG_CATEGORY_MAX_LENGTH = 120
